<ng-container *ngIf="readyToDownload; else notReadyToDownload">
  <ng-container *ngTemplateOutlet="loadedTemplate"></ng-container>
</ng-container>
<ng-template #notReadyToDownload> Loading&hellip; </ng-template>
